import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(timezone);

export default dayjs;

export const DATE_TIME_FORMAT = "MM/DD/YYYY - hh:mm A";

export const getTimestampBucket = (timestamp = Date.now(), numSec = 60) => {
    const timeBucketMS = numSec * 1000;
    return timestamp - (timestamp % timeBucketMS);
};

export const getFlooredDateTime = (dateVal, numSec = 60, options = {}) => {
    const timestamp = dateVal ? new Date(dateVal).valueOf() : Date.now();
    const bucketedT = getTimestampBucket(timestamp, numSec);
    const newDate = new Date(bucketedT);

    if (options?.returnDateObject === true) {
        return newDate;
    }

    return typeof dateVal === "number" ? newDate.valueOf() : newDate.toISOString();
};

export const getTimeZoneAbbreviation = (timeZone, timeZoneName = "short") => {
    const formatter = new Intl.DateTimeFormat("en-US", { timeZone, timeZoneName });
    const formatted = formatter.formatToParts(new Date());
    const timeZoneNamePart = formatted.find((part) => part.type === "timeZoneName");
    return timeZoneNamePart?.value || timeZone;
};

export const getLocalBrowserTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
